import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import API from "../../services/api";

import Loader from "../components/common/Loader/Loader";
import Button from "../components/common/Button/Button";

import ProviderProfileCard from "../components/Provider/ProviderProfileCard";
import OwnerInfoCard from "../components/Provider/OwnerInfoCard";
import BusinessInfoCard from "../components/Provider/BusinessInfoCard";
import AddressCard from "../components/Provider/AddressCard";
import BankDetailsCard from "../components/Provider/BankDetailsCard";
import DocumentsCard from "../components/Provider/DocumentsCard";
import ProviderStatsCard from "../components/Provider/ProviderStatsCard";
import ProviderActionButtons from "../components/Provider/ProviderActionButtons";

import "./ProviderDetails.css";

function ProviderDetails() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [provider, setProvider] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        loadProvider();

    }, []);

    const loadProvider = async () => {

        try {

            const res = await API.get(`/admin/providers/${id}`);

            setProvider(res.data.provider);

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return <Loader />;

    }

    if (!provider) {

        return (

            <div className="provider-details-page">

                <h2>

                    Provider not found

                </h2>

                <Button
                    variant="secondary"
                    onClick={() => navigate("/admin/providers")}
                >

                    Back to Providers

                </Button>

            </div>

        );

    }

    return (

        <div className="provider-details-page">

            <div className="provider-details-header">

                <Button
                    variant="secondary"
                    onClick={() => navigate(-1)}
                >

                    <ArrowLeft size={18} />

                    Back

                </Button>

                <div>

                    <h1>

                        Provider Details

                    </h1>

                    <p>

                        Complete provider profile and verification information.

                    </p>

                </div>

            </div>

            <div className="provider-details-grid">

                <div className="provider-left-column">

                    <ProviderProfileCard provider={provider} />

                    <BusinessInfoCard provider={provider} />

                    <OwnerInfoCard provider={provider} />

                    <AddressCard provider={provider} />

                    <BankDetailsCard provider={provider} />

                </div>

                <div className="provider-right-column">

                    <ProviderStatsCard provider={provider} />

                    <ProviderActionButtons provider={provider} />

                </div>

            </div>

            <DocumentsCard provider={provider} />

        </div>

    );

}

export default ProviderDetails;